
/**
 * A reusable select input component designed for use with React Hook Form.
 *
 * @param {object} props - The component props.
 * @param {string[]} props.list - An array of strings to be used as options.
 * @param {Function} props.register - The `register` function from React Hook Form.
 * @param {string} props.label - The text for the input's label.
 * @param {string} props.field - The name of the field, used for registration and linking the label.
 * @param {object} [props.errors={}] - The errors object from React Hook Form.
 * @param {string} [props.className=''] - Additional classes to apply to the container div.
 * @param {string} [props.placeholder] - Optional placeholder text to show as the first, disabled option.
 */
const SelectBlock2 = ({ list, register, label, field, errors = {}, className = '', placeholder }) => {

  // Combine default and provided classes for better flexibility
  const containerClasses = `w-full flex flex-col gap-1 items-start ${className}`;

  // Determine if there's an error for this field to apply styling
  const hasError = errors[field];

  return (
    <div className={containerClasses}>
      {label && (
        <label htmlFor={field} className="label-text text-md font-bold text-gray-700">
          {label}
        </label>
      )}

      <select
        id={field}
        {...register(field)}
        className={`select select-bordered w-full font-normal ${hasError ? 'select-error' : ''}`}
      // DO NOT use defaultValue here. React Hook Form controls the value.
      // Set the initial value in the parent component's useForm({ defaultValues: ... })
      >
        {placeholder && (
          // This option acts as a placeholder. It's selected if the form value is "" or undefined.
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {list.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>

      {hasError && (
        <span className="text-red-500 text-sm mt-1">{errors[field].message}</span>
      )}
    </div>
  );
};

export default SelectBlock2;